export default "__VITE_ASSET__DtGReANO__"